class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('.mini-cart-close');
    this.siteNavbar = document.querySelector('site-navbar');
	  this.closeButton.addEventListener('click', this.handleCloseButton.bind(this));
  }

  handleCloseButton() { 
    this.siteNavbar.handleClose();
  }

  renderContents(parsedState) {

    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        // document.querySelector('cart-items').classList.remove('is-empty');
        document.querySelector('.main-cart-footer--mini-cart').classList.remove('is-empty');
    }));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '#main-cart-footer',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);